import { isEmpty, capitalize, split, get, pipe } from 'lodash/fp'
import { FC } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { SearchFiltersHumanizedRefinement } from 'search'
import { Card as BaseCard } from 'shared/components/CardDeprecated'
import styled from 'styled-components'
import { SearchQA } from 'shared/dataAttributes'
import SizeTile from './SizeTile'
import TileGrid from './TileGrid'
import sendTrackingEvent from 'mParticle/sendTrackingEvent'

const Card = styled(BaseCard)<{ isHidden: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
`

interface FilterSizeSelectionProps {
  attribute: string
  hide: boolean
  items
  refine(value)
  isExpanded?: boolean
}

const FilterSizeSelection: FC<FilterSizeSelectionProps> = ({
  hide,
  attribute,
  items,
  refine,
  isExpanded,
}) => {
  const getGender = pipe(split('_'), get(2), capitalize)
  const gender = getGender(attribute)

  const handleRefinement = (value: string) => {
    // This might not work with constructur refinement
    // attribute is one of
    // size_us_men
    // size_us_women
    // size_us_youths
    const modifiedFilterName = attribute.replace('_us_', 's_')
    sendTrackingEvent('FILTER_APPLY_TAP', {
      page: window?.location?.href,
      filter_name: modifiedFilterName.toLowerCase(),
      filter_selection: value[value.length - 1],
    })
    refine(value)
  }

  return !isEmpty(items) ? (
    <Card
      title={SearchFiltersHumanizedRefinement()[attribute]}
      isExpanded={isExpanded}
      isHidden={hide}
      qaAttr={`${SearchQA.Filter}${gender}`}
    >
      <TileGrid>
        {items.map(({ label, value, isRefined }) => (
          <SizeTile
            data-qa={`${SearchQA.FilterGenderOptions}${gender}`}
            key={label}
            isSelected={isRefined}
            onClick={() => {
              handleRefinement(value)
            }}
          >
            {label}
          </SizeTile>
        ))}
      </TileGrid>
    </Card>
  ) : null
}

export default connectRefinementList(FilterSizeSelection)
